export const contactsData = {
    email: 'mugishomatgedeon@gmail.com',
    phone: '+250794422520',
    address: 'Kigali, Rwanda',
    github: 'https://github.com/GedeonMatabaro',
    facebook: 'https://www.facebook.com/gedeon.mugisho.m/',
    linkedIn: 'https://www.linkedin.com/in/mugishomatgedeon/',
    twitter: 'https://twitter.com/gedeon_matabaro',
    medium: '#',
    stackOverflow: '#',
    devUsername: "#"
}